export default __webpack_public_path__ + "static/media/notice.5c1bc69b.svg";